<template>
  <div>
    <!-- Las areas de negocio de operaciones de interify son 10 y 9  -->
    <SolicitudesInterify v-if="areaNegocioId == 15" />
    <!-- Las areas de negocio de emails es 3  -->
    <SolicitudesLlamadas v-if="areaNegocioId == 3"/>
    <!-- Las areas de negocio de llamadas inbound es 6  -->
    <SolicitudesEmails v-if="areaNegocioId == 6 || areaNegocioId == 3"/>

  </div>
</template>

<script>
import SolicitudesInterify from "./FlujoInterify/SolicitudesInterify.vue";
import SolicitudesEmails from "./FlujoEmails/SolicitudesEmails.vue"
import SolicitudesLlamadas from "./FlujoLlamadasInbound/SolicitudesLlamadas.vue"
import { getSolicitudById } from "@/services/solicitudes/Solicitudes.js";

export default {
  components: {
    SolicitudesInterify,
    SolicitudesEmails,
    SolicitudesLlamadas
  },
  data() {
    return {
      solicitud: {},
      areaDeNegocio: null,
      areaNegocioId: null,
    };
  },
  methods: {
    async getSolicitud() {
      this.solicitud = await getSolicitudById(this.$route.params.id);

      try {
        this.body = this.solicitud.body && typeof this.solicitud.body === 'string'
          ? JSON.parse(this.solicitud.body)
          : {};
      } catch (error) {
        console.warn("No se pudo parsear el body como JSON:", this.solicitud.body, error);
        this.body = {};
      }

      this.areaNegocioId = this.solicitud.areaNegocioId
        ? this.solicitud.areaNegocioId
        : this.body.areaNegocioId
        ? this.body.areaNegocioId
        : 15  ;
    }
  },
  mounted() {
    this.getSolicitud();
  },
};
</script>
